export const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'white',
    borderRadius: 2,
    maxHeight: '90vh',
    width: '70%',
    overflow: 'scroll',
    outline: 0
}

export const modalHeadingStyle = {
    color: 'white',
    bgcolor: '#0a204a',
    fontWeight: 'bold',
    p: 2,
    fontSize: 20
}

export const modalBoxStyle = {
    p: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 2
}

export const modalFormStyle = {
    width: '100%'
}

export const legendStyle = {
    bgcolor: 'white',
    borderStyle: 'solid',
    borderWidth: 2,
    borderColor: '#88a9b2',
    borderRadius: 2,
    px: 1,
    '&:hover': {
        '.shortText': {
            display: 'none'
        },
        '.normalText': {
            display: 'inline'
        }
    }
}

export const legendIconStyle = {
    paddingRight: 1.5,
    minWidth: 0,
    paddingBottom: 0.5
}

export const legendIconImageStyle = {
    width: 30,
    height: 30
}

export const legendTextStyle = {
    fontSize: 15
}

export const popupHeaderStyle = {
    color: 'white',
    bgcolor: '#0a204a',
    borderRadius: 2,
    p: 2
}

export const popupMainHeadingStyle = {
    color: '#99e3fe',
    fontWeight: 'bold',
    fontSize: 15,
    '&.MuiTypography-root': {
        m: 0
    }
}

export const popupSecondaryHeadingStyle = {
    color: '#ccf1ff',
    fontSize: 14,
    '&.MuiTypography-root': {
        m: 0
    }
}

export const popupTertiaryHeadingStyle = {
    fontStyle: 'italic',
    fontSize: 13,
    '&.MuiTypography-root': {
        m: 0
    }
}

export const checkboxStyle = {
    color: '#99e3fe',
    '&.Mui-checked': {
        color: '#99e3fe'
    }
}

export const chipStyle = {
    bgcolor: '#99e3fe',
    '&.MuiChip-clickable:hover': {
        bgcolor: '#87d1ec'
    },
    '&.MuiChip-root': {
        color: '#0a204a'
    }
}

export const chipArrayStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    '.MuiChip-root': {
        fontSize: 12,
        mt: 0.5,
        mx: 0.25
    },
    mt: 1.5
}

export const tableStyle = {
    borderStyle: 'solid',
    borderWidth: 1.5,
    '.MuiTableCell-root': {
        fontSize: 13,
        borderBottom: 'none',
        borderTop: '1px solid rgba(224, 224, 224, 1)'
    },
    '.MuiTableCell-head': {
        color: '#0a204a',
        fontWeight: 'bold'
    },
    my: 2
}

export const tableIconCellStyle = {
    p: 0,
    pt: 0.5
}

export const secondaryTableCellStyle = {
    '&.MuiTableCell-root': {
        borderTop: 'none',
        py: 0
    }
}

export const listStyle = {
    p: 0,
    mb: 2,
    '.MuiListItem-root': {
        py: 0
    }
}

export const listItemHeadingStyle = {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: 14
}

export const listItemBodyStyle = {
    fontSize: 13
}

export const messageStyle = {
    color: 'rgba(0, 0, 0, 0.87)',
    fontStyle: 'italic',
    fontSize: 13,
    py: 2
}